import { FC, forwardRef } from 'react'
import { Icon } from '@rsuite/icons'
import { IconProps } from '@rsuite/icons/lib/Icon'

const NoOrderListSvg = forwardRef<SVGSVGElement>((props, ref) => (
  <svg
    {...props}
    width="100"
    height="100"
    viewBox="0 0 100 100"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    ref={ref}
  >
    <path
      d="M50 100C77.6142 100 100 77.6142 100 50C100 22.3858 77.6142 0 50 0C22.3858 0 0 22.3858 0 50C0 77.6142 22.3858 100 50 100Z"
      fill="url(#paint0_linear_31410_25977)"
    />
    <g filter="url(#filter0_dd_31410_25977)">
      <circle
        cx="50"
        cy="50"
        r="32"
        fill="white"
      />
    </g>
    <path
      d="M41.6641 42.8109H55.6641C55.9226 42.8109 56.1706 42.7082 56.3535 42.5254C56.5363 42.3425 56.6391 42.0945 56.6391 41.8359C56.6391 41.5774 56.5363 41.3294 56.3535 41.1465C56.1706 40.9637 55.9226 40.8609 55.6641 40.8609H41.6641C41.4055 40.8609 41.1575 40.9637 40.9746 41.1465C40.7918 41.3294 40.6891 41.5774 40.6891 41.8359C40.6891 42.0945 40.7918 42.3425 40.9746 42.5254C41.1575 42.7082 41.4055 42.8109 41.6641 42.8109Z"
      fill="#A1D9CE"
      stroke="#A1D9CE"
      strokeWidth="0.2"
    />
    <path
      d="M54.3057 50C54.3057 49.7414 54.203 49.4934 54.0202 49.3106C53.8373 49.1277 53.5893 49.025 53.3307 49.025H41.6641C41.4055 49.025 41.1575 49.1277 40.9746 49.3106C40.7918 49.4934 40.6891 49.7414 40.6891 50C40.6891 50.2586 40.7918 50.5066 40.9746 50.6894C41.1575 50.8723 41.4055 50.975 41.6641 50.975H53.3307C53.5893 50.975 53.8373 50.8723 54.0202 50.6894C54.203 50.5066 54.3057 50.2586 54.3057 50Z"
      fill="#A1D9CE"
      stroke="#A1D9CE"
      strokeWidth="0.2"
    />
    <path
      d="M41.6641 57.1891C41.4055 57.1891 41.1575 57.2918 40.9746 57.4746C40.7918 57.6575 40.6891 57.9055 40.6891 58.1641C40.6891 58.4226 40.7918 58.6706 40.9746 58.8535C41.1575 59.0363 41.4055 59.1391 41.6641 59.1391H48.6641C48.9226 59.1391 49.1706 59.0363 49.3535 58.8535C49.5363 58.6706 49.6391 58.4226 49.6391 58.1641C49.6391 57.9055 49.5363 57.6575 49.3535 57.4746C49.1706 57.2918 48.9226 57.1891 48.6641 57.1891H41.6641Z"
      fill="#A1D9CE"
      stroke="#A1D9CE"
      strokeWidth="0.2"
    />
    <path
      d="M59.0027 32.7391H59.0026L40.3359 32.7391L40.3359 32.7391C39.1627 32.7403 38.0379 33.207 37.2084 34.0365C36.3788 34.8661 35.9122 35.9908 35.9109 37.164V37.1641L35.9109 62.8307L35.9109 62.8308C35.9122 64.004 36.3788 65.1287 37.2084 65.9583C38.0379 66.7878 39.1627 67.2544 40.3359 67.2557H52.3526C52.5979 67.2557 52.8332 67.1583 53.0067 66.9848C53.1802 66.8113 53.2776 66.5761 53.2776 66.3307C53.2776 66.0854 53.1802 65.8501 53.0067 65.6767C52.8332 65.5032 52.5979 65.4057 52.3526 65.4057H40.3359C39.6533 65.405 38.9987 65.1334 38.516 64.6507C38.0332 64.1679 37.7617 63.5134 37.7609 62.8307V37.1641C37.7617 36.4814 38.0332 35.8269 38.516 35.3441C38.9987 34.8614 39.6533 34.5898 40.336 34.5891H59.0026C59.6853 34.5898 60.3398 34.8614 60.8226 35.3441C61.3053 35.8269 61.5768 36.4814 61.5776 37.1641V49.0874C61.5776 49.3327 61.6751 49.568 61.8485 49.7415C62.022 49.9149 62.2573 50.0124 62.5026 50.0124C62.7479 50.0124 62.9832 49.9149 63.1567 49.7415C63.3302 49.568 63.4276 49.3327 63.4276 49.0874V37.1641V37.164C63.4263 35.9908 62.9597 34.8661 62.1302 34.0365C61.3006 33.207 60.1758 32.7403 59.0027 32.7391Z"
      fill="#054C2E"
      stroke="#054C2E"
      strokeWidth="0.1"
    />
    <path
      d="M37 39C37 36.2386 39.2386 34 42 34H58.4829C61.2443 34 63.4829 36.2386 63.4829 39V67.3027H42C39.2386 67.3027 37 65.0642 37 62.3027V39Z"
      fill="#054C2E"
    />
    <path
      d="M60.5993 52.286L60.5988 52.286C58.6931 52.2881 56.8661 53.046 55.5185 54.3935C54.171 55.7411 53.4131 57.5681 53.411 59.4738V59.4743C53.411 60.896 53.8325 62.2858 54.6224 63.4679C55.4123 64.6501 56.5349 65.5714 57.8484 66.1155C59.1619 66.6595 60.6073 66.8019 62.0017 66.5245C63.3961 66.2472 64.6769 65.5625 65.6822 64.5572C66.6875 63.5519 67.3722 62.2711 67.6495 60.8767C67.9269 59.4823 67.7845 58.0369 67.2405 56.7234C66.6964 55.4099 65.7751 54.2873 64.5929 53.4974C63.4108 52.7075 62.021 52.286 60.5993 52.286ZM65.099 66.2086C63.7673 67.0985 62.2015 67.5735 60.5998 67.5736C58.4523 67.5713 56.3935 66.7172 54.875 65.1987C53.3565 63.6802 52.5024 61.6214 52.5 59.474C52.5001 57.8722 52.9751 56.3064 53.865 54.9746C54.7549 53.6427 56.0199 52.6045 57.4998 51.9915C58.9798 51.3785 60.6083 51.2181 62.1794 51.5306C63.7505 51.8431 65.1937 52.6145 66.3264 53.7472C67.4591 54.8799 68.2305 56.3231 68.543 57.8942C68.8555 59.4653 68.6951 61.0938 68.0821 62.5738C67.4691 64.0537 66.431 65.3187 65.099 66.2086Z"
      fill="#054C2E"
      stroke="white"
    />
    <circle
      cx="60.8086"
      cy="59.4688"
      r="7"
      fill="#054C2E"
    />
    <path
      d="M58.2321 60.4399H59.8429V62.0507C59.8429 62.307 59.9447 62.5529 60.126 62.7341C60.3072 62.9154 60.5531 63.0172 60.8094 63.0172C61.0657 63.0172 61.3115 62.9154 61.4928 62.7341C61.674 62.5529 61.7759 62.307 61.7759 62.0507V60.4399H63.3866C63.643 60.4399 63.8888 60.3381 64.0701 60.1568C64.2513 59.9756 64.3531 59.7298 64.3531 59.4734C64.3531 59.2171 64.2513 58.9713 64.0701 58.79C63.8888 58.6088 63.643 58.507 63.3866 58.507H61.7759V56.8962C61.7759 56.6398 61.674 56.394 61.4928 56.2128C61.3115 56.0315 61.0657 55.9297 60.8094 55.9297C60.5531 55.9297 60.3072 56.0315 60.126 56.2128C59.9447 56.394 59.8429 56.6398 59.8429 56.8962V58.507H58.2321C57.9758 58.507 57.7299 58.6088 57.5487 58.79C57.3674 58.9713 57.2656 59.2171 57.2656 59.4734C57.2656 59.7298 57.3674 59.9756 57.5487 60.1568C57.7299 60.3381 57.9758 60.4399 58.2321 60.4399Z"
      fill="white"
    />
    <path
      d="M42.3906 41.8031H56.3906C56.6492 41.8031 56.8972 41.7004 57.0801 41.5176C57.2629 41.3347 57.3656 41.0867 57.3656 40.8281C57.3656 40.5695 57.2629 40.3215 57.0801 40.1387C56.8972 39.9558 56.6492 39.8531 56.3906 39.8531H42.3906C42.132 39.8531 41.884 39.9558 41.7012 40.1387C41.5183 40.3215 41.4156 40.5695 41.4156 40.8281C41.4156 41.0867 41.5183 41.3347 41.7012 41.5176C41.884 41.7004 42.132 41.8031 42.3906 41.8031Z"
      fill="white"
      stroke="white"
      strokeWidth="0.2"
    />
    <path
      d="M55.0323 49C55.0323 48.7414 54.9296 48.4934 54.7467 48.3106C54.5639 48.1277 54.3159 48.025 54.0573 48.025H42.3906C42.132 48.025 41.884 48.1277 41.7012 48.3106C41.5183 48.4934 41.4156 48.7414 41.4156 49C41.4156 49.2586 41.5183 49.5066 41.7012 49.6894C41.884 49.8723 42.132 49.975 42.3906 49.975H54.0573C54.3159 49.975 54.5639 49.8723 54.7467 49.6894C54.9296 49.5066 55.0323 49.2586 55.0323 49Z"
      fill="white"
      stroke="white"
      strokeWidth="0.2"
    />
    <path
      d="M42.3906 56.1891C42.132 56.1891 41.884 56.2918 41.7012 56.4746C41.5183 56.6575 41.4156 56.9055 41.4156 57.1641C41.4156 57.4226 41.5183 57.6706 41.7012 57.8535C41.884 58.0363 42.132 58.1391 42.3906 58.1391H49.3906C49.6492 58.1391 49.8972 58.0363 50.0801 57.8535C50.2629 57.6706 50.3656 57.4226 50.3656 57.1641C50.3656 56.9055 50.2629 56.6575 50.0801 56.4746C49.8972 56.2918 49.6492 56.1891 49.3906 56.1891H42.3906Z"
      fill="white"
      stroke="white"
      strokeWidth="0.2"
    />
    <defs>
      <filter
        id="filter0_dd_31410_25977"
        x="8"
        y="8"
        width="84"
        height="84"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood
          floodOpacity="0"
          result="BackgroundImageFix"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="4" />
        <feGaussianBlur stdDeviation="2" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.7625 0 0 0 0 0.7625 0 0 0 0 0.7625 0 0 0 0.12 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_31410_25977"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset />
        <feGaussianBlur stdDeviation="5" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0"
        />
        <feBlend
          mode="normal"
          in2="effect1_dropShadow_31410_25977"
          result="effect2_dropShadow_31410_25977"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect2_dropShadow_31410_25977"
          result="shape"
        />
      </filter>
      <linearGradient
        id="paint0_linear_31410_25977"
        x1="50"
        y1="0"
        x2="50"
        y2="100"
        gradientUnits="userSpaceOnUse"
      >
        <stop
          stopColor="#B1F946"
          stopOpacity="0.19"
        />
        <stop
          offset="1"
          stopColor="#B1F946"
          stopOpacity="0.39"
        />
      </linearGradient>
    </defs>
  </svg>

))

const NoOrderListsIcon: FC<IconProps> = (props) => (
  <Icon
    {...props}
    as={NoOrderListSvg}
  />
)

export default NoOrderListsIcon
